import PageV2Comp from "../../components/page_v2/page_v2_comp";
import { ModelProfileContextProvider } from "./context/model_profile_context";
import ModelProfileComp from "./components/model_profile_comp";
import { useParams, useLocation } from "react-router-dom";

const ModelProfilePage = () => {
  const { name } = useParams();
  const location = useLocation();
  
  // If we're on the /eve route, use "eve" as the name
  const profileName = location.pathname === "/eve" ? "eve" : name;

  return (
    <ModelProfileContextProvider name={profileName}>
      <ModelProfileComp />
    </ModelProfileContextProvider>
  );
};

export default ModelProfilePage;
